import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "mb-1 flex justify-start" }
const _hoisted_3 = ["type", "value"]
const _hoisted_4 = ["value"]




export default /*#__PURE__*/_defineComponent({
  __name: 'Select',
  props: {
  labelValue: {
    type: String,
    required: true,
  },
  modelValue: {
    type: String,
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;

function onChange(event: Event) {
  const value = event.target.value;
  emits("update:modelValue", value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(props.labelValue), 1),
    _createElementVNode("select", {
      type: _ctx.type,
      class: "border-2 required rounded",
      value: __props.modelValue,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (onChange($event)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
        return (_openBlock(), _createElementBlock("option", {
          key: index,
          value: option.value
        }, _toDisplayString(option.text), 9, _hoisted_4))
      }), 128))
    ], 40, _hoisted_3)
  ]))
}
}

})